import { Injectable } from '@angular/core';
import { BottomSheetType } from '@app/components/bottom-sheet/bottom-sheet.model';
import {
    Platform,
} from '@ionic/angular';
import { BoxxUtilsService } from './BoxxUtils.service';
import { Browser } from '@capacitor/browser';
import { LocalStorageNativeService } from './NativeLocalStorage.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { Clipboard } from '@capacitor/clipboard';

@Injectable({
    providedIn: 'root',
})
export class QRService {
    currentLanguage: string = 'en';
    translations: any;
    destroyed$ = new Subject<boolean>();

    constructor(
        private utils: BoxxUtilsService,
        private platform: Platform,
        public storageService: LocalStorageNativeService,
        private translate: TranslateService
    ) {
        this.translate
            .get(['CLIPBOARD'])
            .pipe(takeUntil(this.destroyed$))
            .subscribe((t: any) => {
                this.translations = t;
            });
        this.getCurrentLanguage();
    }

    async getCurrentLanguage() {
        const language = await this.storageService.getItem('selectedLanguage');
        if (language || language !== null) {
            this.currentLanguage = language;
        }
    }

    async openQRComponent(sites: any[]) {
        let dataSites = [];
        sites.forEach(site => {
            if (site.type === 'agency_website' || site.type === 'website') {
                dataSites.push({
                    key: site.type,
                    value: 'TABS.qr.option_website',
                    icon: 'QR_web',
                    icon_type: 'src',
                    class: 'custom',
                    url: site.url
                });
            }
            else if (site.type === 'shop') {
                dataSites.push({
                    key: 'shop',
                    value: 'TABS.qr.option_store',
                    icon: 'QR_store',
                    icon_type: 'src',
                    class: 'custom',
                    url: site.url
                });
            }
            else if (site.type === 'directory') {
                dataSites.push({
                    key: 'directory',
                    value: 'TABS.qr.option_website',
                    icon: 'QR_web',
                    icon_type: 'src',
                    class: 'custom',
                    url: site.url
                });
            }
        });
        this.utils.openBottomSheet({
            data: [],
            site: dataSites,
            firstTimeOpen: true,
            type: BottomSheetType.qr,
            initialBreakpoint: 1,
            breakpoints: [0, 1],
            canClose: true,
            title: '',
            maxHeigth: 80
        }).then((data: any) => {
            if (data?.value) {
                console.log('data: ', data)
                this.actionsSiteSelected(data?.value, data?.url);
            }
        });

    }

    async actionsSiteSelected(option: string, url: string) {
        if (option === 'openUrl') {
            await Browser.open({ url });
        }
        else if (option === 'copyUrl') {
            if (this.platform.is('desktop') || this.platform.is('mobileweb')) {
                if (navigator.clipboard) {
                    try {
                        await navigator.clipboard.writeText(url).then(
                            () => {
                                this.utils.showToastSuccess({
                                    message: this.currentLanguage === 'es' ? "URL copiada en el Portapapeles" : "URL copied to Clipboard"
                                });
                            },
                            () => {
                                this.utils.showToastError({
                                    message: this.currentLanguage === 'es' ? "Ocurrió un error al intentar copiar la URL" : "An error occurred while trying to copy the URL"
                                });
                            }
                        );
                    } catch (err) {
                        this.utils.showToastError({
                            message: this.currentLanguage === 'es' ? "Ocurrió un error al intentar copiar la URL" : "An error occurred while trying to copy the URL"
                        });
                    }
                }
            } else {
                Clipboard.write({
                    string: url
                }).then(
                    () => {
                        this.utils.showToastSuccess({
                            message: this.translations.CLIPBOARD.urlCopiedToClipboard,
                        });
                    },
                    () => {
                        this.utils.showToastError({
                            message: this.translations.CLIPBOARD.urlCopiedToClipboardError,
                        });
                    }
                );
            }
        }
    }
}
